import { isArray } from 'utils';

const getQuestionIndexById = (questionArray = [], questionId) => {
  return questionId && isArray(questionArray) ? questionArray.map(q => q.id).indexOf(questionId) : -1;
};

export default getQuestionIndexById;
